import { useMutation } from "@tanstack/react-query";
import {
  type AuthUpdatePurchaseInput,
  type AuthUpdatePurchaseResponse,
  authUpdatePurchase,
} from "../api/private/authUpdatePurchase";
import { useToken } from "../contexts/TokenContext";

interface UseAuthUpdatePurchaseOptions {
  onSuccess?: (data: AuthUpdatePurchaseResponse) => void;
  onError?: (error: Error) => void;
}

export const useAuthUpdatePurchase = (options?: UseAuthUpdatePurchaseOptions) => {
  const { idToken } = useToken();

  return useMutation<
    AuthUpdatePurchaseResponse,
    Error,
    { uuid: string; params: AuthUpdatePurchaseInput }
  >({
    mutationFn: ({ uuid, params }: { uuid: string; params: AuthUpdatePurchaseInput }) => {
      if (!idToken) {
        throw new Error("No authentication token available");
      }
      return authUpdatePurchase(idToken, uuid, params);
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
    retry: false, // Don't retry authentication-related requests
  });
};
